// filepath: src/components/CompareListenerModal.js
import React, {useEffect, useState} from 'react';
import {Alert, Button, message, Modal, Space, Spin, Tag, Typography} from 'antd';
import DiffViewer from './DiffViewer';
import {getListenersByEvent, updateListener} from '../api/systemEventApi';
import {pickList} from '../api/http';

const { Text } = Typography;

const CompareListenerModal = ({ open, onClose, row, onApplied }) => {
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState(null);

  const [dbDesc, setDbDesc] = useState('');
  const [rtDesc, setRtDesc] = useState('');

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      if (!open) return;
      setLoading(true); setError(null);
      try {
        const initialDb = (row?.description ?? row?.dsctn ?? '');
        const initialRt = (row?.rtDesc ?? '');
        if (mounted) { setDbDesc(initialDb); setRtDesc(initialRt); }
        if (!initialRt && row?.eventKey) {
          try {
            const res = await getListenersByEvent(row.eventKey);
            const list = pickList(res) || [];
            const found = list.find(li => (li.beanClass === row.beanClass && li.methodName === row.methodName));
            if (found && mounted) setRtDesc(found.description || '');
          } catch (_) { /* ignore */ }
        }
      } catch (e) {
        if (mounted) setError(e);
      } finally { if (mounted) setLoading(false); }
    };
    load();
    return () => { mounted = false; setDbDesc(''); setRtDesc(''); setError(null); setUpdating(false); };
  }, [open, row]);

  const equal = String((dbDesc||'')).trim() === String((rtDesc||'')).trim();

  const handleApply = async () => {
    if (!row?.listenerId) { message.warning('DB 리스너가 아닙니다.'); return; }
    try {
      setUpdating(true);
      await updateListener(row.listenerId, { dsctn: rtDesc });
      message.success('설명을 갱신했습니다.');
      try { onApplied && onApplied(); } catch (_) {}
      onClose && onClose();
    } catch (e) {
      message.error('갱신 실패');
    } finally { setUpdating(false); }
  };

  const title = (
    <Space wrap>
      <Typography.Text strong>리스너 비교</Typography.Text>
      {row?.eventName && <Tag color="blue">{row.eventName}</Tag>}
      {row?.beanClass && <Text code>{row.beanClass}</Text>}
      {row?.methodName && <Text code>{row.methodName}</Text>}
    </Space>
  );

  return (
    <Modal open={open} onCancel={onClose} footer={null} width={900} title={title}>
      {loading && <Spin />}
      {error && <Alert type="error" showIcon message="비교 로드 실패" description={String(error?.message || '오류가 발생했습니다.')} style={{ marginBottom: 12 }} />}

      {!loading && !error && (
        <>
          <Space style={{ justifyContent:'space-between', width:'100%', marginBottom: 8 }} align="center">
            <Space>
              <Tag color={equal ? 'green' : 'orange'}>{equal ? '동일' : '다름'}</Tag>
              {!equal && <Tag color="orange">변경 항목: 설명</Tag>}
            </Space>
            <Space>
              <Tag color="green">DB</Tag>
              <Tag color="geekblue">런타임</Tag>
            </Space>
          </Space>

          <div style={{ marginBottom: 8 }}>
            <Typography.Text type="secondary">설명 비교</Typography.Text>
          </div>
          <DiffViewer left={dbDesc} right={rtDesc} leftLabel="DB 설명" rightLabel="런타임 설명" />

          <Space style={{ justifyContent:'flex-end', width:'100%', marginTop: 12 }}>
            {row?.listenerId && (
              <Button type="primary" onClick={handleApply} loading={updating} disabled={equal}>갱신</Button>
            )}
          </Space>
        </>
      )}
    </Modal>
  );
};

export default CompareListenerModal;
